import React, { useState, ChangeEvent, useEffect } from 'react'

import { toast } from 'react-toastify'

import { useHistory } from 'react-router-dom'

import ProfileContractor from '../../../../../presentation/pages/contractors/profile'

import { useMe } from '../../../../../presentation/contexts/me'

import { makeContractors } from '../../../../usecases/contractors/remote-contractors-factory'
import { makeUpdateUser } from '../../../../usecases/update-user/remote-update-user-factory'

import {
  isHttpError,
  HelperAmplify,
  HelperViaCep,
  // getRoute,
} from '../../../../../presentation/helpers'
import { RoutesEnum /*  Authority */ } from '../../../../../presentation/enums'

import IContractor from '../../../../../presentation/interfaces/contractor'

const MakeProfileContractor = () => {
  document.title = 'BuscarMédicos - Perfil'

  const [contractor, setContractor] = useState<IContractor | null>(null)

  const [isEditing, setIsEditing] = useState<{ [key: string]: boolean }>({
    corporateName: false,
    email: false,
    phone: false,
    about: false,
    address: false,
    observation: false,
    site: false,
    availability: false,
    specialties: false,
  })

  const [editableFields, setEditableFields] = useState<Partial<IContractor> | null>(null)

  const [cep, setCep] = useState(contractor?.address?.zipcode)

  const [number, setNumber] = useState(contractor?.address?.number)

  const history = useHistory()

  const { me, updateMe } = useMe()

  useEffect(() => {
    const loadContractor = async () => {
      try {
        if (!me) {
          return
        }

        const data = await makeContractors().loadById(me?.id as number)
        setContractor(data)
        setEditableFields(data)
      } catch (error) {
        const httpError = isHttpError(error)

        if (httpError) {
          toast.error(httpError.message)
        } else {
          throw error
        }
      }
    }

    loadContractor()
  }, [me])

  const handleLogout = async () => {
    updateMe(null as any)

    await HelperAmplify.signOut()

    history.push('/')
  }

  const handleChangePassword = () => {
    history.push(RoutesEnum.CHANGE_PASSWORD)
  }

  const handleEditMode = (field: string) => {
    setIsEditing((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }))

    setEditableFields((prevState) => ({
      ...prevState,
      [field]: (contractor as any)?.[field],
    }))
  }

  const handleEditableField = async (
    field: string,
    value: string | string[],
  ) => {
    setEditableFields((prevState) => ({
      ...prevState,
      [field]: value,
    }))
  }

  const handleSave = async (field: string) => {
    setIsEditing((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }))

    const fieldMapper = () => {
      switch (field) {
        case 'availability':
          return 'availabilities'
        default:
          return field
      }
    }

    try {
      await makeUpdateUser().update(Number(me?.id), {
        [fieldMapper()]: (editableFields as any)?.[field],
      })

      setContractor((prevState: any) => ({
        ...prevState,
        [field]: (editableFields as any)?.[field],
      }))

      toast.success('Dados atualizados com sucesso!')
    } catch (error) {
      const httpError = isHttpError(error)

      if (httpError) {
        toast.error(httpError.message)
      } else {
        throw error
      }
    }
  }

  /* const handleEditPlan = () => {
    history.push(getRoute(RoutesEnum.PLANS, { type: Authority.CONTRACTOR }))
  } this will be used later, do not remove */

  const handleEditAddress = async () => {
    const address = await HelperViaCep.getAdressByCep(cep as string)

    if (address) {
      setEditableFields((prevState: any) => ({
        ...prevState,
        address: {
          ...prevState.address,
          street: address.street,
          neighborhood: address.neighborhood,
          city: address.city,
          state: address.state,
        },
      }))
    }
  }

  const handleEditCep = (evt: ChangeEvent<HTMLInputElement>) => {
    const formattedValue = evt.target.value
      .replace(/\D/g, '')
      .slice(0, 8)
      .replace(/(\d{5})(\d{3})/, '$1-$2')

    setCep(formattedValue)
  }

  const handleEditNumber = (evt: ChangeEvent<HTMLInputElement>) => {
    const { value } = evt.target

    const formattedValue = value.replace(/\D/g, '')

    setNumber(formattedValue)

    setEditableFields((prevState: any) => ({
      ...prevState,
      address: {
        ...prevState.address,
        number: formattedValue,
      },
    }))
  }

  const handleClick = () => {
    history.push(RoutesEnum.EDIT_HEADER_CONTRACTOR)
  }

  if (!contractor || !editableFields) {
    return null
  }

  const profileContractorProps = {
    contractor: {
      ...contractor,
      imgUrl: contractor.document.find((doc: any) => doc.url.startsWith('images/'))?.url,
    },
    editableFields,
    isEditing,
    cep,
    number,
    handleLogout,
    handleChangePassword,
    handleEditMode,
    handleEditableField,
    handleSave,
    // handleEditPlan this will be used later, do not remove,
    handleEditAddress,
    handleEditCep,
    handleEditNumber,
    handleClick,
  }

  return <ProfileContractor {...profileContractorProps} />
}

export default MakeProfileContractor
